import React, { useEffect, useState } from "react";
import { Carousel } from "@one-thd/sui-carousel";
import { Link, Typography } from "@one-thd/sui-atomic-components";
import { SkeletonPlaceholder } from "./skeletonPlaceholder/skeletonPlaceholder";
import { carouselBreakpoints } from "../constants/carousel";
import { PaintUtils } from "../utils/paint";
import { TColorSwatch } from "./colorSwatch/colorSwatch";
import { ErrorLoading } from "./errorStates/loadError";
import { PAINT_PURCHASE_HISTORY_LINK } from "../constants/links";
import usePaintOrderHistory from "../hooks/usePaintOrderHistory";
import dataModel from "../dataModel";

type TPaintPurchaseHistoryProps = {
  userId: string;
  customerAccountId: string;
  tmxProfileId: string;
};

const PaintPurchaseHistory = ({
  userId,
  customerAccountId,
  tmxProfileId,
}: TPaintPurchaseHistoryProps) => {
  const { data, loading, error, refetch } = usePaintOrderHistory(
    userId,
    customerAccountId,
    tmxProfileId,
  );
  const [colorSwatches, setColorSwatches] = useState<Array<TColorSwatch>>();

  useEffect(() => {
    if (data?.paintOrderHistory) {
      const {
        paintOrderHistory: { paintOrderLineItems },
      } = data;

      const swatches = PaintUtils.assembleSwatches(paintOrderLineItems);

      if (swatches) {
        setColorSwatches(swatches);
      }
    }
  }, [data]);

  if (loading) return <SkeletonPlaceholder />;
  if (error) return <ErrorLoading reload={refetch} />;

  return (
    <div data-testid="pph-history-container">
      <Carousel
        title={<Typography variant="h3">Paint Purchase History</Typography>}
        action={<Link href={PAINT_PURCHASE_HISTORY_LINK}>View All</Link>}
        breakpoints={carouselBreakpoints}
        disableShadow
        disableMargin
      >
        {colorSwatches}
      </Carousel>
    </div>
  );
};

PaintPurchaseHistory.displayName = "PaintPurchaseHistory";
PaintPurchaseHistory.dataModel = dataModel;

export { PaintPurchaseHistory };
